var React = require('react');
var TrioFunnel = require('../_common/TrioFunnel');

var SoloFunnel = React.createClass({

    propTypes: {
        index: React.PropTypes.number,
        play: React.PropTypes.bool,
        storyWidth: React.PropTypes.number,
        storyHeight: React.PropTypes.number,
        width: React.PropTypes.number,
        height: React.PropTypes.number,
        border: React.PropTypes.number,
        objs: React.PropTypes.object,
        container: React.PropTypes.object,
        backgroundKey: React.PropTypes.string
    },

    getDefaultProps: function()
    {
        return {
            texts: [
                {
                    title: 'Catherine\nSummers',
                    subtitle: 'Ministre des\n finances',
                    opts: {
                        x: 50,
                        y: 480
                    }
                }
            ],
            backgroundKey: 'trioFunnelbg'
        }
    },

    render: function()
    {
        return (
            <TrioFunnel solo={true} minister={true} {...this.props} />
        );
    }
});

module.exports = SoloFunnel;



// WEBPACK FOOTER //
// ./js/components/frames/C-TooBig/4-SoloFunnel.jsx